import { CloseIcon } from "components/icons"
import { SearchPopupContent as BaseSearchPopupContent } from "../SearchPopupContent"
import {
  DirectorySkeletonCard,
  DirectoryOccupantCard,
} from "components/domains/directory"
export const SearchPopupContent = (props) => {
  const { searchResultProps, ...restProps } = props
  return (
    <BaseSearchPopupContent
      {...restProps}
      closeIcon={CloseIcon}
      searchResultProps={{
        ...searchResultProps,
        renderSearchItem: DirectoryOccupantCard,
        renderLoadingItem: DirectorySkeletonCard,
      }}
      searchBasePopupProps={{
        dialogProps: { disablePortal: true, hideBackdrop: false },
      }}
    />
  )
}
